import { jwtDecode } from "jwt-decode";

export interface DecodedJwtPayload {
  exp?: number;
  [key: string]: any;
}

export function decodeToken(token: string | null | undefined): DecodedJwtPayload | null {
  if (!token || typeof token !== "string") return null;
  try {
    return jwtDecode<DecodedJwtPayload>(token);
  } catch {
    return null;
  }
}

export function getClaim(
  decoded: DecodedJwtPayload | null,
  claimKeys: string[]
): any {
  if (!decoded) return null;
  for (const key of claimKeys) {
    if (decoded[key] !== undefined && decoded[key] !== null) {
      return decoded[key];
    }
  }
  return null;
}

export function getRolesFromToken(decoded: DecodedJwtPayload | null): string[] {
  const roleClaim = getClaim(decoded, [
    "role",
    "roles",
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
  ]);

  if (!roleClaim) return [];
  if (Array.isArray(roleClaim)) return roleClaim.map(String);
  return [String(roleClaim)];
}

export function getPermissionsFromToken(decoded: DecodedJwtPayload | null): string[] {
  const permClaim = getClaim(decoded, ["permissions", "Permissions", "permission", "Permission"]);

  if (!permClaim) return [];
  if (Array.isArray(permClaim)) return permClaim.map(String);
  return [String(permClaim)];
}

export function isTokenExpired(decoded: DecodedJwtPayload | null): boolean {
  if (!decoded || !decoded.exp) return true;
  const currentTime = Math.floor(Date.now() / 1000);
  return decoded.exp < currentTime;
}
